import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ColorPalette {
  id: number;
  name: string;
  colors: string[];
}

@Component({
  selector: 'app-color-palette-view',
  templateUrl: './color-palette-view.component.html',
  styleUrls: ['./color-palette-view.component.css'],
})
export class ColorPaletteViewComponent {
  @Input() selectedPalette: ColorPalette;
  @Output() change = new EventEmitter<void>();

  onClickChange() {
    this.change.emit();
  }
  }

